import { IconCircleCheck as TablerIconCircleCheck } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconCircleCheck = /*#__PURE__*/ createOutlineIcon(
  TablerIconCircleCheck,
  'IconCircleCheck',
);
